import { render, staticRenderFns } from "./ExpertImgModule.vue?vue&type=template&id=8205a254&scoped=true"
import script from "./ExpertImgModule.vue?vue&type=script&lang=js"
export * from "./ExpertImgModule.vue?vue&type=script&lang=js"
import style0 from "./ExpertImgModule.vue?vue&type=style&index=0&id=8205a254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8205a254",
  null
  
)

export default component.exports